<template>
  <div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header p-3">
          <h6 class="modal-title"></h6>
          <button class="close text-white" data-dismiss="modal" aria-label="Close" @click="close">
            <span aria-hidden="true"><cancel-icon class="close-icon" style="height: 30px !important;
    width: 30px !important;
    color: #fff;"></cancel-icon></span>
          </button>
        </div>
        <div class="modal-body">
            <div class="logo-wrapper">
              <div style="height: 60px;width: 60px;justify-content: center;">
                <img :src="logo" style="height:100%;">
              </div>
            </div>
            <div class="app-details-wrapper">
              <div class="app-version" style="display: inline-flex;"> 
                <div style="color: #666;">Version: </div> 
                <div style="padding: 0px 8px;">
                  <div>{{releaseId}}</div>
                </div>
              </div>
              <div class="app-version" style="display:inline-flex">
                <div style="color: #666;">Build Info:</div>
                <div style="padding: 0px 8px;">
                <div>{{buildInfo}}</div>
                </div>
              </div>
            </div>
            <div style="position: absolute;
            bottom: 12px;
            display: flex;
            inset-inline-start:32%;
            color: #919191;
            font-size: 12px;">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="currentColor" class="bi bi-c-circle" viewBox="0 0 16 16" style="position: relative;
              top: 2px;
              inset-inline-end: 4px;">
                <path d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.146 4.992c-1.212 0-1.927.92-1.927 2.502v1.06c0 1.571.703 2.462 1.927 2.462.979 0 1.641-.586 1.729-1.418h1.295v.093c-.1 1.448-1.354 2.467-3.03 2.467-2.091 0-3.269-1.336-3.269-3.603V7.482c0-2.261 1.201-3.638 3.27-3.638 1.681 0 2.935 1.054 3.029 2.572v.088H9.875c-.088-.879-.768-1.512-1.729-1.512"/>
              </svg>
              2024 Workflowlabs Private Limited
            </div>
      </div>
    </div>
  </div>
  </div>
</template>


<script>
import {mapActions} from "vuex";
import cancelIcon from "./InlineCancelField.vue"
import Utils from '../../components.utils';


export default {
  data: () => ({
    dialog: true,
    logo: Utils.getLogoWithText(),
    versionInfo: {},
    releaseId: "",
    buildInfo:"-",
  }),
  components:{
        'cancel-icon':cancelIcon
      },
  methods:{
      close(){
        this.$emit('close')
    },
    fetchVersionInfo(){
      this.getAboutInfo().then((data)=>{
        this.versionInfo = data;
        this.releaseId = "v" + this.versionInfo["release_version"]
        this.buildInfo = this.versionInfo["git_short_hash"];
      })
    },
    ...mapActions("actions", ["getAboutInfo"]),
    ...mapActions("tags", ["updateExistingTag"]),
  },
  created(){
    this.fetchVersionInfo();
  }
}
</script>

<style lang="scss" scoped>
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;
.modal-dialog {
    max-width: 550px;
    width: 550px;
    margin: 0;
    padding: 0;
  }
  
  .modal-content {
    height: 270px;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $secondary-border-color;
    .modal-body{
      background: $primary-background;
      padding: 1rem;
      display: inline-block;
      flex-direction: unset;
    }
  }

.modal {
  text-align: center;
  padding: 0!important;
  display:block;
}
.modal-header .close {
    // margin: -1rem -13px -1rem auto !important;
    margin:0px !important;
    padding: 0px !important;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.btn{
    font-size:14px !important;
    height:100%;
}

.border{
    border: $border-color !important;
}

.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    height: 58px;
    .modal-title{
      color:$text-color;
    }
}

.modal-header .close {
    // margin: -1rem -13px -1rem auto !important;
    margin:0px !important;
    padding: 0px !important;
}

.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}

.app-details-wrapper{
        display: grid;
        flex-direction: row;
        justify-content: center;
        padding-inline-start: 1%;
        padding-top: 0%;
    .app-title{
        font-size: 40px;
        text-align: start;
    }

    .app-version{
        text-align: start;
        color:$secondary-text-color;
        user-select: text!important;
        cursor: text;
    }
}

.logo-wrapper{
    width: 50%;
    padding: 17px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    position:relative;
}


</style>